import React, { useEffect } from "react";
import BjornImage from "../../images/Bjorn_square.png";
import DavidImage from "../../images/David_square.png";
import EliasImage from "../../images/Elias_square.png";
import HugoImage from "../../images/Hugo_square.png";
import MartinImage from "../../images/Martin_square.png";
import TeamMemberTag from "../presentational/TeamMemberTag";
import TankIcon from "../../images/TankIconW.svg";
import CodeIcon from "../../images/CodeIconW.svg";
import GraphicsIcon from "../../images/GraphicsIconW.svg";

const About = ({ setBgColor, updateScreenSize }) => {
  useEffect(() => {
    setBgColor("#281B4B");
    document.documentElement.scrollTop = 0;
  }, [setBgColor]);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "stretch",
          width: "90%",
          padding: "10px",
          justifyContent: "center",
        }}
      >
        <TeamMemberTag
          imglink={BjornImage}
          icon={TankIcon}
          name="Björn Winge"
          role="Physical Interaction"
          description="My responsibility in this project has been the Tangibles. I have designed, drawn, 3D-printed and built the tangibles. I have also programmed the input script for Unity to recognize the tangibles type, position and orientation. It has been an educational experience and really fun to incorporate a wide spread of previous learnings from my time at KTH."
          githubURL="https://github.com/BearAndersson"
          websiteURL="http://www.bearlyinfocus.com/"
        />
        <TeamMemberTag
          imglink={DavidImage}
          icon={GraphicsIcon}
          name="David Magnusson"
          role="Graphics and Animations"
          description="My main focus for this project has been model creation as well as rigging and animation for characters, and exporting to Unity. The biggest challenge has been learning since I have not had too much experience in modelling. Besides learning modelling and everything around it I have learnt how to cooperate and communicate within a team of 5 members which I believe will be very useful as well in the future!"
          linkedInURL="https://www.linkedin.com/in/david-magnusson-293403161/"
          githubURL="https://github.com/davidmagnussson"
          websiteURL="https://davidmagnussson.github.io/portfolio/#/"
        />
        <TeamMemberTag
          imglink={EliasImage}
          icon={GraphicsIcon}
          name="Elias Åkerlund"
          role="Graphics and Animations"
          description="Graphics and character design has been my focus. I also helped implement the characters to the game and made sure they functioned properly. Since I was new to Unity, my main challenge was learning about the application. I had a lot of fun developing the game and will bring this experience to future projects."
          linkedInURL="https://www.linkedin.com/in/elias-%C3%A5kerlund-ab23b4156/"
          githubURL="https://github.com/sejfz"
        />

        <TeamMemberTag
          imglink={HugoImage}
          icon={CodeIcon}
          name="Hugo Bergqvist"
          role="Gameplay development"
          description="My main part in this project has been coding, which has been a fun but challenging process! Apart from getting more familiar with the software, it's been a great learning experience to sustain a workflow in which a team of five can work efficiently."
          websiteURL="https://hugobergqvist.com"
          githubURL="https://github.com/hugobergqvist"
          linkedInURL="https://www.linkedin.com/in/hugo-bergqvist-70b338141/"
        />
        <TeamMemberTag
          imglink={MartinImage}
          icon={CodeIcon}
          name="Martin Mosesson"
          role="Gameplay development"
          description="My primary focus has been to make the game mechanics run smoothly through creating and coding relevant scripts for the different assets in the game, and implementing them in a smart way. It has been a great experience to work with Unity and my group. I've learned a lot and I feel proud of what our group has accomplished."
          linkedInURL="https://www.linkedin.com/in/martin-mosesson-086612173/"
          githubURL="https://github.com/murtson"
          websiteURL="https://my-portfolio-heroku.herokuapp.com/"
        />
      </div>
    </div>
  );
};

export default About;
